import {
  reducer as featureAccountReducer,
  REDUCER_NAME as FEATURE_ACCOUNT_REDUCER_NAME,
} from "@gogoro/feature-account/services/reducer"
import { combineReducers } from "redux"

import { contractReducer } from "./contract"
import { globalUiReducer } from "./globalUi"
import { orderScooterReducer } from "./orderScooter"
import { productReducer } from "./product"
import { scooterReducer } from "./scooter"
import { testRideReducer } from "./testRide"
import { userStateReducer } from "./userState"

export default combineReducers({
  globalUi: globalUiReducer,
  userState: userStateReducer,
  product: productReducer,
  scooter: scooterReducer,
  orderScooter: orderScooterReducer,
  contract: contractReducer,
  testRide: testRideReducer,
  [FEATURE_ACCOUNT_REDUCER_NAME]: featureAccountReducer,
})
